import { Image, Menu, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Logo from "../../assets/images/logo-for-logins.png";
import { AuthContext } from "../../context/AuthContext";
import DashboardIcon from "../../assets//images/side_nav/dashboard_icn.svg";
import UserManagerIcon from "../../assets//images/side_nav/usermanager_icn.svg";
import ServiceManagerIcon from "../../assets//images/side_nav/service_manager_icn.svg";
import ProductManagerIcon from "../../assets//images/side_nav/compliant.png";
import FinancialManagerIcon from "../../assets//images/side_nav/financial_manager_icn.svg";
import ComplianceManagerIcon from "../../assets//images/side_nav/audit_manager_icn.svg";
import AnalyticsManagerIcon from "../../assets//images/side_nav/anylystic_icn.svg";
import ContentManagerIcon from "../../assets//images/side_nav/conatent_icn.svg";
import EmailTemplateIcon from "../../assets//images/side_nav/email_icn.svg";
import LogoutIcon from "../../assets//images/side_nav/logout_icn.svg";
import { Severty, ShowToast } from "../../helper/toast";
import DeleteModal from "../DeleteModal";

export const menuItems = [
  // {
  //   key: "DashboardManager",
  //   path: "/dashboard",
  //   icon: DashboardIcon,
  //   label: "Dashboard",
  //   isShow: true,
  // },
    {
        key: "Gym Owner",
        label: "Gym Owner",
        path: "/vendors",
        icon:UserManagerIcon,
      },
  // {
  //   key: "BassnessSetup",
  //   label: "User Manager",
  //   icon: UserManagerIcon,
  //   children: [
  //     {
  //       key: "users",
  //       label: "Users",
  //       path: "/users",
  //     },
    
  //     {
  //       key: "admin-user",
  //       label: "Admins",
  //       path: "/admin-user",
  //     },
  //   ],
  // },
  // {
  //   key: "ServiceCatalogue",
  //   label: "Service Manager",
  //   icon: ServiceManagerIcon,
  //   path: "/service",
  // },
  // {
  //   key: "ServiceCatalogueCatalogue",
  //   label: "Exercise Manager",
  //   icon: ServiceManagerIcon,
  //   path: "/product",
  // },
  // {
  //   key: "order-list",
  //   label: "Order Manager",
  //   icon: ProductManagerIcon,
  //   path: "/order-list",
  // },
  // {
  //   key: "staff",
  //   label: "Financial Manager",
  //   icon: FinancialManagerIcon,
  //   children: [
  //     {
  //       key: "transactions",
  //       label: "Transactions",
  //       path: "/transactions",
  //     },
  //     {
  //       key: "vendor-payouts",
  //       label: "Vendor Pay-outs",
  //       path: "/vendor-payouts",
  //     },
  //   ],
  // },
  // {
  //   key: "calender",
  //   icon: ComplianceManagerIcon,
  //   label: "Compliance and Audit Manager",
  //   path: "/calender",
  // },
  // {
  //   key: "orders_analytics",
  //   label: "Analytics Manager",
  //   icon: AnalyticsManagerIcon,
  //   path: "/order",
  // },
  {
    key: "orders_content",
    label: "Content Manager",
    icon: ContentManagerIcon,
    path: "/content",
  },
  {
    key: "orders_email",
    label: "Email Templates",
    icon: EmailTemplateIcon,
    path: "/email-template",
  },
  {
    key: "logout",
    label: "Logout",
    icon: LogoutIcon,
    isLogout: true,
  },
];

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const { userProfile, logout, setUserProfile } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [menuLinks, setMenuLinks] = useState([]);
  const [menuMode, setMenuMode] = useState("vertical");

  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  const isActiveLink = (pattern, pathname) => {
    const regexPattern = new RegExp(`^${pattern.replace("*", ".*")}$`);
    return regexPattern.test(pathname);
  };

  const renderTitle = (item) => {
    return (
      <>
        <Image preview={false} src={item.icon} />
        <span className="label">{item.label}</span>
      </>
    );
  };

  useEffect(() => {
    setLoading(true);
    // if (!userProfile) return;
    // if (userProfile.role == "admin") {
    setMenuLinks(menuItems);
    setLoading(false);
    //   return;
    // }
    // const newArray = menuItems.filter((item) => {
    //   if (item.isShow) {
    //     return true;
    //   } else {
    //     // console.log(menuItems, "Vendor");
    //     return userProfile?.permission?.includes(item?.key);
    //   }
    //   //return item;
    // });

    // const links = newArray.filter((item) => {
    //   if (item?.children?.length) {
    //     return true;
    //   } else if (!item?.children) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // });

    // setMenuLinks(links);
    // setLoading(false);
  }, []);

  useEffect(() => {
    // setMenuLinks(menuItems);
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMenuMode("inline");
      } else {
        setMenuMode("vertical");
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {loading ? (
        [1, 2, 3, 4, 5, 6].map((item) => <Skeleton active key={item} />)
      ) : (
        <>
          <div className="brand-logo">
            <NavLink to="/vendors" className="imgOuter">
              <img  src={Logo} alt="Logo" />
            </NavLink>
          </div>

          <Menu mode="inline" className="sideNavMain">
            {menuLinks.map((item) => {
              if (item.children) {
                return (
                  <Menu.SubMenu
                    key={item.key}
                    title={
                      <div className="submenu-title">
                        <img
                          src={item.icon}
                          alt=""
                          style={{ width: "20px", height: "20px " }}
                        />
                        <span className="label">{item.label}</span>
                      </div>
                    }
                  >
                    {item.children.map((child) => (
                      <Menu.Item key={child.key}>
                        <NavLink to={child.path}>{child.label}</NavLink>
                      </Menu.Item>
                    ))}
                  </Menu.SubMenu>
                );
              }

              if (item.isLogout) {
                return (
                  <Menu.Item
                    key={item.key}
                    onClick={() => setIsLogoutModalVisible(true)}
                  >
                    <Link className="logout-menubar"> {renderTitle(item)}</Link>
                  </Menu.Item>
                );
              }

              return (
                <Menu.Item key={item.key}>
                  <NavLink to={item.path}>{renderTitle(item)}</NavLink>
                </Menu.Item>
              );
            })}
          </Menu>
        </>
      )}

      {/* Logout Modal */}
      {isLogoutModalVisible && (
        <DeleteModal
          title="Logout"
          subtitle="Are you sure you want to log out as Admin?"
          show={isLogoutModalVisible}
          hide={() => setIsLogoutModalVisible(false)}
          onOk={async () => {
            setIsLogoutModalVisible(false);
            try {
              await logout();
              ShowToast("Logout successful", Severty.SUCCESS);
            } catch (error) {
              console.error("Logout error:", error);
              ShowToast("Logout failed", Severty.ERROR);
            }
          }}
        />
      )}
    </>
  );
}

export default Sidenav;
